import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { LoginComponent } from './core/auth/login/login.component';
import { NriSignupComponent } from './core/auth/nri-signup/nri-signup.component';
import { ServiceProviderSignupComponent } from './core/auth/service-provider-signup/service-provider-signup.component';
import { authGuard } from './core/guard/auth.guard';
import { ForgotPasswordComponent } from './core/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './core/auth/reset-password/reset-password.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'nri-signup', component: NriSignupComponent },
  { path: 'service-provider-signup', component: ServiceProviderSignupComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'nri',
        canActivate: [authGuard],
        children: [
          {
            path: 'dashboard',
            loadComponent: () => import('./nri/pages/dashboard/dashboard.component')
              .then(m => m.DashboardComponent)
          },
          {
            path: 'travel',
            loadComponent: () =>
              import('./nri/pages/travel-setup/travel-setup.component')
                .then(c => c.TravelSetupComponent),
          },
          {
            path: 'travel-companion',
            loadComponent: () =>
              import('./nri/pages/travel-companion/travel-companion.component')
                .then(c => c.TravelCompanionComponent),
          },
          {
            path: 'wellness-care',
            loadComponent: () =>
              import('./nri/pages/wellness-care/wellness-care.component')
                .then(c => c.WellnessCareComponent),
          },
          {
            path: 'wellness-care/:id',
            loadComponent: () =>
              import('./nri/pages/wellness-care/wellness-ticket.component')
                .then(c => c.WellnessTicketComponent),
          },
          {
            path: 'my-profile',
            loadComponent: () =>
              import('./nri/pages/my-profile/my-profile.component')
                .then(c => c.MyProfileComponent),
          },
        ],
      },
      {
        path: 'service-provider',
        canActivate: [authGuard],
        children: [
          {
            path: 'dashboard',
            loadComponent: () =>
              import('./service-provider/pages/dashboard/dashboard.component')
                .then(c => c.DashboardComponent),
          },
        ],
      },
       {
        path: 'admin',
        canActivate: [authGuard],
        children: [
          {
            path: 'properties',
            loadComponent: () =>
              import('./admin/pages/properies/properies.component')
                .then(c => c.ProperiesComponent),
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];


